import { render, staticRenderFns } from "./IconsViewPage.vue?vue&type=template&id=0f2bb102&"
import script from "./IconsViewPage.vue?vue&type=script&lang=js&"
export * from "./IconsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports